import React from 'react';
import PropTypes from 'prop-types';

const GenderField = (props) => {
  const { value, onChange } = props;

  const genderOptions = [
    { label: 'Male', value: 'm' },
    { label: 'Female', value: 'f' },
    { label: 'Other/Prefer Not to Say', value: 'o' },
  ];

          {genderOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
           ))}


  return (
      <div class="pgn__form-select">
        <label htmlFor="gender">Gender</label>
        <select
          id="gender"
          name="gender"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="" data-isdefault={true} selected={true}></option>
          {genderOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
           ))}

        </select>
      </div>
  );
};

GenderField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default GenderField;
